const e={hasAnimatedSinceResize:!0,hasEverUpdated:!1};export{e as globalProjectionState};
